import { render, staticRenderFns } from "./UnavailabilityDayForm.vue?vue&type=template&id=1bca4d08&"
import script from "./UnavailabilityDayForm.vue?vue&type=script&lang=js&"
export * from "./UnavailabilityDayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports